import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, PageHeader, Tabs, Row, Col } from 'antd'

import RightParamSets from './RightParamSets'
import ParamGroups from './ParamGroups'

@inject((store: any) => {
    const { popupStore, rightParamSetStore, paramGroupsStore } = store
    return { popupStore, rightParamSetStore, paramGroupsStore }
})
@observer
class RightsTables extends Component<any, any> {
    async componentDidMount() {
        const { rightParamSetStore, paramGroupsStore } = this.props
        await rightParamSetStore.getList()
        await paramGroupsStore.getList()
    }
    render() {
        const { TabPane } = Tabs
        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="הגדרת טבלאות פרמטרים"
                    subTitle="בחר באחת מהאפשוריות להגדרה"
                />
                <Row style={{ padding: '0 2rem' }}>
                    <Col>
                        <Tabs type="card">
                            <TabPane tab="טבלאות" key="TABLES">
                                <RightParamSets />
                            </TabPane>
                            <TabPane tab="קבוצות פרמטרים" key="PARAM_GROUPS">
                                <ParamGroups />
                            </TabPane>
                        </Tabs>
                    </Col>
                </Row>
            </Layout>
        )
    }
}

export default withRouter(RightsTables)
